/**
 * For a given index toggle on if currently off, and vice versa.
 * When allowing multiple, other selected items will be preserved
 * When another is added. Otherwise selecting one deselects another
 * Like radio button vs checkbox
 * @param {number} index The item's index
 * @param {number[]} selectedItems An array of selected indexes
 * @param {boolean} allowMultiple Limit to one or allow multiple items to be selected
 */
export const toggleSelectedItem = (index, prevSelected) => {
  const isSelected = prevSelected === index;
  return isSelected ? null : index;
};
